import { formatDate } from '$components'
import { Text } from '$components'

export type DateCellProps = {
  date?: string | null
}

export function DateCell({ date }: DateCellProps) {

  return (
    <Text type="s" className="text-nowrap">
      { date ? formatDate(date) : '-' }
    </Text>
  )
}
